import { SectionHead } from "@/components/site/SectionHead";

const LESSONS = [
  { n: "01", title: "Document before, not after", body: "Condition evidence captured before a loss is far harder to dispute than photos taken once damage has occurred." },
  { n: "02", title: "Know your policy now", body: "Exclusions, deductibles, and endorsements decide outcomes. Read them before you need them." },
  { n: "03", title: "Notice deadlines matter", body: "Many policies and state rules set strict reporting windows. Late notice can weaken or void a claim." },
  { n: "04", title: "Mitigate and record it", body: "Policies typically require reasonable steps to prevent further damage — keep receipts and photos of every step." },
  { n: "05", title: "Keep a claim journal", body: "Log every call, email, inspection, and person you speak with. Organized records shorten disputes." },
  { n: "06", title: "Bring in experts early", body: "Engineers, estimators, and counsel are most valuable before positions harden — not after." },
];

export const ClaimsEducation = () => (
  <section id="claims-education" className="relative py-20 sm:py-24 md:py-32 btr-bg-charcoal overflow-hidden" data-testid="claims-education-section">
    <div className="absolute inset-0 btr-grid opacity-20 pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-6">
      <SectionHead
        badge="Claims Education"
        title={<>What every owner should know <span className="text-[#a2020b]">before</span> a claim.</>}
        lede="Practical principles that protect your position. Educational guidance only — not legal advice."
      />
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 rounded-xl overflow-hidden mt-12 border border-white/5">
        {LESSONS.map((l, i) => (
          <article key={l.n} className="btr-reveal group bg-[#0a0a0b] p-7 hover:bg-[#120607] transition-colors" style={{ transitionDelay: `${i * 50}ms` }} data-testid={`claims-lesson-${i}`}>
            <div className="font-display text-[11px] tracking-[0.3em] text-[#a2020b]">{l.n}</div>
            <h3 className="font-display font-bold text-white text-lg mt-3 tracking-tight">{l.title}</h3>
            <p className="font-body text-zinc-400 text-sm mt-3 leading-relaxed">{l.body}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);
